import { uuid } from "../index";

export function createDescriptionTextNode(message) {
	// create the helper element and add content
	const messageNode = document.createTextNode(message);

	const helperText = document.createElement("span");
	helperText.id = `help-text:${uuid()}`;
	helperText.classList.add("sr-only");
	helperText.appendChild(messageNode);

	return helperText;
}
